<template>
	<div>
		<!-- 拖拽容器 -->
		<!-- transform: `translate(${currentX}px, ${currentY}px)`, -->
		<div class="drag-container"  ref="targetDiv"
			@touchstart.passive="handleTouchStart" 
			@touchmove.passive="handleTouchMove" 
			@touchend.passive="handleTouchEnd" 
			:style="{
				left: position.left + 'px',
				top: position.top + 'px',
				zIndex: isDragging ? '99999' : '',
				position: isDragging ? 'fixed' : ''
			}"
			>
			<slot>
				<img :src="imgUrl" width="50" 
				class="border border-1 border-light-subtle" style="touch-action: none" />
			</slot>
			<div v-if="showPosition" class="position-indicator">
				X: {{ currentX }} / Y: {{ currentY }}
			</div>
		</div>
		<div ref="targetDiv2">
			<img :src="imgUrl"  v-if="isDragging" 
			width="50" 	class="border border-1 border-light-subtle img-pl" style="touch-action: none;" />
		</div>
	</div>
    
  </template>
   
  <script>
  export default {
	name: 'MobileDraggable',
	props: {
	  imgUrl: {
		type: String,
		default: ''
	  },
	  menuId:{
		type: String,
		default: ''
	  },
	  // 初始位置 
	  initialPosition: {
		type: Object,
		default: () => ({ x: 0, y: 0 })
	  },
	  // 边界限制 
	  boundary: {
		type: Object,
		default: () => ({ 
		  minX: -Infinity, 
		  maxX: Infinity,
		  minY: -Infinity,
		  maxY: Infinity 
		})
	  },
	  // 显示坐标指示器 
	  showPosition: {
		type: Boolean,
		default: false 
	  }
	},
	data() {
	  return {
		currentX: this.initialPosition.x, 
		currentY: this.initialPosition.y, 
		startX: 0,
		startY: 0,
		isDragging: false,
		touchIdentifier: null,
		position:{
			left:0,
			top:0,
			left2: 0,
			top2: 0,
		}

	  }
	},

	mounted() {
		// this.getDivPostion()
		// window.onscroll = () => {
		// 	this.getDivPostion()
		// }
	},


	methods: {
		getDivPostion(){
			// this.$nextTick(() => {
			// 	const rect = this.$refs.targetDiv.getBoundingClientRect(); 
			// 	console.log('屏幕左上角坐标X:', rect.left,  '坐标Y:', rect.top); 
			// });
		},
	  // 触摸开始事件 
	  handleTouchStart(event) {
		if (this.isDragging)  return 
		

		const rect = this.$refs.targetDiv.getBoundingClientRect();
		this.position = {
			left: rect.left,
			top: rect.top,
			left2: rect.left,
			top2: rect.top,
		};
		// console.log(position,this.currentX,this.currentY,this.startX,this.startY)


		const touch = event.touches[0] 
		console.log('touch',touch)
		this.touchIdentifier  = touch.identifier  
		this.startX  = touch.clientX  - this.currentX  
		this.startY  = touch.clientY  - this.currentY  
		this.isDragging  = true 
	  },
	  // 触摸移动事件 
	  handleTouchMove(event) {
		if (!this.isDragging)  return 
		
		const touch = Array.from(event.touches) 
		  .find(t => t.identifier  === this.touchIdentifier) 
		if (!touch) return 
   
		// 计算新位置 
		let newX = touch.clientX  - this.startX  
		let newY = touch.clientY  - this.startY  
		
		// 边界约束 
		newX = Math.max(this.boundary.minX,  
		  Math.min(newX,  this.boundary.maxX)) 
		newY = Math.max(this.boundary.minY,  
		  Math.min(newY,  this.boundary.maxY)) 
		
		// 更新位置 
		this.currentX  = newX 
		this.currentY  = newY 
		
		this.position = {
			...this.position,
			left:this.position.left2 + newX,
			top:this.position.top2 + newY,
		};

		
		// 触发自定义事件 
		this.$emit('dragging', { x: newX, y: newY })
	  },
	  // 触摸结束事件 
	  handleTouchEnd() {
		if (!this.isDragging)  return 
		
		this.isDragging  = false 
		this.touchIdentifier  = null 

        this.currentX=this.initialPosition.x
		this.currentY=this.initialPosition.y
		this.startX=0
		this.startY=0
		
		

		this.$emit('drag-end', { x: this.position.left,  y: this.position.top ,img:this.imgUrl,menuid:this.menuId})
		this.position = {
				left: 0,
				top: 0,
				left2: 0,
				top2: 0,
			};
	
	  }
	},
	watch: {
	  // 动态边界更新 
	  boundary: {
		deep: true,
		handler(newVal) {
		  this.currentX  = Math.max(newVal.minX,  
			Math.min(this.currentX,  newVal.maxX)) 
		  this.currentY  = Math.max(newVal.minY,  
			Math.min(this.currentY,  newVal.maxY)) 
		}
	  }
	}
  }
  </script>
  <style scoped>
  .img-pl{
	filter: grayscale(10%);
	opacity: .5;
  }
  /* 容器基础样式 */
  .drag-container {
	position: relative;
	touch-action: none; /* 禁用默认触摸行为 */
	will-change: transform; /* 启用GPU加速 */
	cursor: grab;
	user-select: none;
	display: inline-flex;
    background: #fff;
	-webkit-tap-highlight-color: transparent;
    fill-content: content;
  }
   
  /* 拖拽激活状态 */
  .drag-container:active {
	cursor: grabbing;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
   
  /* 坐标指示器 */
  .position-indicator {
	position: absolute;
	bottom: -32px;
	left: 50%;
	transform: translateX(-50%);
	padding: 4px 12px;
	background: rgba(0, 0, 0, 0.8);
	color: white;
	border-radius: 16px;
	font-size: 12px;
	white-space: nowrap;
  }
   
  /* 移动端优化 */
  @media (hover: none) {
	.drag-container {
	  cursor: pointer;
	}
  }
  </style>